// Capsula de preco: pilula branca so com sombra, sem borda. E uma imagem
// esticavel (stretchX/stretchY), entao a mesma serve para "R$ 295" e para
// "R$ 1,2 mi" - o MapLibre estica so o miolo e preserva as pontas.
export const CAPSULA = 'capsula-preco';

const ALTURA = 26;
const LARGURA = 88;
// Um pixel a menos que a metade da altura: sobra uma faixa reta para o
// stretchY. Faixa de altura zero faz o MapLibre nao desenhar a imagem.
const RAIO = ALTURA / 2 - 1;
const MARGEM = 7;  // folga transparente ao redor, onde a sombra cabe
const DPR = 2;     // desenha em 2x para nao serrilhar em tela retina

function pilula(ctx, x, y, l, a, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + l, y, x + l, y + a, r);
  ctx.arcTo(x + l, y + a, x, y + a, r);
  ctx.arcTo(x, y + a, x, y, r);
  ctx.arcTo(x, y, x + l, y, r);
  ctx.closePath();
}

function desenha() {
  const l = (LARGURA + MARGEM * 2) * DPR;
  const a = (ALTURA + MARGEM * 2) * DPR;
  const tela = document.createElement('canvas');
  tela.width = l;
  tela.height = a;
  const ctx = tela.getContext('2d');
  ctx.scale(DPR, DPR);
  // Sombra larga e fraca para o volume, e uma curta logo abaixo, que e o
  // que separa a pilula do mapa claro.
  ctx.fillStyle = '#ffffff';
  ctx.shadowColor = 'rgba(15, 23, 42, 0.18)';
  ctx.shadowBlur = 8;
  ctx.shadowOffsetY = 3;
  pilula(ctx, MARGEM, MARGEM, LARGURA, ALTURA, RAIO);
  ctx.fill();
  ctx.shadowColor = 'rgba(15, 23, 42, 0.22)';
  ctx.shadowBlur = 2.5;
  ctx.shadowOffsetY = 1;
  ctx.fill();
  ctx.shadowColor = 'transparent';
  ctx.fill();
  return { l, a, px: ctx.getImageData(0, 0, l, a) };
}

export function registraCapsula(mapa) {
  if (mapa.hasImage(CAPSULA)) return;
  const { l, a, px } = desenha();
  const p = MARGEM * DPR;
  // `content` e a area branca, de fora a sombra: e nela que o texto encaixa
  mapa.addImage(CAPSULA, { width: l, height: a, data: px.data }, {
    pixelRatio: DPR,
    stretchX: [[(MARGEM + RAIO) * DPR, (MARGEM + LARGURA - RAIO) * DPR]],
    stretchY: [[(MARGEM + RAIO) * DPR, (MARGEM + ALTURA - RAIO) * DPR]],
    content: [p, p, (MARGEM + LARGURA) * DPR, (MARGEM + ALTURA) * DPR],
  });
}
